import {QueryClient} from '@tanstack/react-query'
export const reactQueryClient = new QueryClient()

export enum ServiceFamiliesTypes {
  ADAPTIVENETWORK = 'adaptive-networks',
  DATACENTRECLOUD = 'data-centre-cloud',
}

export enum ServiceFamiliesTitle {
  'adaptive-networks' = 'Adaptive networks',
  'data-centre-cloud' = 'Data centre and cloud',
}

export enum ServiceFamiliesTabTitle {
  'adaptive-networks' = 'By site address',
  'data-centre-cloud' = 'By data centre',
}

export enum ServiceFamiliesMapTitle {
  'adaptive-networks' = 'Services map',
  'data-centre-cloud' = 'Data centre map',
}

export enum ServiceFamiliesTableTitle {
  'adaptive-networks' = 'Services table',
  'data-centre-cloud' = 'Data centre table',
}

export enum ServiceFamiliesFlags {
  'adaptive-networks' = 'eligibleServiceTypesForGlobalNetworkTile',
  'data-centre-cloud' = 'eligibleGlobalProductCodeForDCC',
}
